export const environment = {
    production: false,
    config: {
        appName: 'Primăria Sectorului 4',
        appDescription: 'inMonitoring Sector 4 ',
        fromTokenValid:
            'https://development.auth-core.webproductionlabs.com/api/login',
        tokenKey: 'wpl-local-operator-app-token', // this token is used for every request where is needed
        userKey: 'wpl-local-operator-app-user', // here we find local storage with minimal user data
        storageKey: 'wpl-local-operator', // here we find key for predefined local storage for app functionalities
        copyrightText: 'Copyright © Direcția de Urbanism Sector 4 - 2023',
        defaultLNG: 'ro',
        emailRegex:
            '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$',
        codeSMSRegex: /^[0-9]+$/,
        phoneRegex: '[0-9]{6,20}',
        cnpRegex: '[0-9]{13,13}',
        validatorsAccrossApp: {
            minPassword: 8,
            maxPassword: 30,
            emailMaxLength: 50,
            minStringLength: 2,
            maxStringLength: 60,
            minSmsCodeLength: 1,
            maxSmsCodeLength: 1,
        },
        customNotifications: {
            icons: {
                success: 'success',
                error: 'error',
                info: 'info',
                warning: 'warning',
            },
            headers: {
                success: 'Succes',
                error: 'Eroare',
                successForm: 'Felicitări!',
            },
            generalMessages: {
                error:
                    'Ne pare rau, dar am întampinat o problemă. Vă rugăm să reîncercați. Dacă problema persistă, vă rugăm să ne contactați prin butonul de suport IT.',
            },
        },
        romanianLanguageDataTable: {
            sEmptyTable: 'Niciun rezultat găsit',
            sInfo: 'Afișate de la _START_ până la _END_ din _TOTAL_ înregistrări',
            sInfoEmpty: 'Afișate de la 0 până la 0 din 0 înregistrări',
            sInfoFiltered: '(filtrat din _TOTAL_ înregistrări)',
            sInfoPostFix: '',
            sInfoThousands: ',',
            sLengthMenu: 'Afișează _MENU_ înregistrări pe pagină',
            sLoadingRecords: 'Încărcare...',
            sProcessing: 'Procesare...',
            sSearch: 'Caută:',
            sZeroRecords: 'Niciun rezultat găsit',
            oPaginate: {
                sFirst: 'Prima',
                sLast: 'Ultima',
                sNext: 'Următoarea',
                sPrevious: 'Anterioară',
            },
            oAria: {
                sSortAscending: ': activează pentru a sorta coloana crescător',
                sSortDescending: ': activează pentru a sorta coloana descrescător',
            },
        },
    },
    interop: {
        basePath: 'https://development.monit-core.webproductionlabs.com/',
        clientId: 9,
        moduleId: 9,
        monitoring: {
            authorizeShortToken: 'authorization_code/',
            notifications: {
                authNotifications: 'api/proiect/auth-notifications',
            },
            maps: {
                searchPlaces: 'api/places',
                getPlaceData: 'api/place/', // + id
            },
            file: {
                fileUpload: 'api/upload-file-register',
                fileUploadBase64: 'api/upload-file-register-base64',
            },
            proiecte: {
                listProiecte: 'api/project',
                listDTProiecte: 'api/proiecte/list-dt',
                storeProiect: 'api/project',
                listResponsabili: 'api/proiecte/responsabili/list',
                listOperatori: 'api/proiecte/operatori-teren/list',
                listActiveDepartamente: 'api/proiecte/departamente/list-active',

                viewProiect: 'api/proiect/', // + id
                sendMesaj: 'api/proiecte/proiect/mesaj/', // + id
                istoricMesaje: 'api/proiecte/proiect/istoric/', // + id?automated=value

                updateTermene: 'api/proiecte/proiect/update-termene/', // + id
                actualizareStatus: 'api/proiecte/proiect/actualizare-status/', // + id
                updateAdresa: 'api/proiecte/proiect/update-adresa/', // + id
                actualizareInformatii: 'api/proiecte/proiect/actualizare-informatii/', // + id
                startActivitate: 'api/proiecte/proiect/start-activitate/', // + id
                amanareActivitate: 'api/proiecte/proiect/amanare-activitate/', // + id
                amanareFinalizare: 'api/proiecte/proiect/amanare-finalizare/', // + id
                finalizare: 'api/proiecte/proiect/finalizare/', // + id

                listResponsabiliByDirectie: 'api/proiecte/directie-compartiment-responsibles/', // + id/id
                setResponsabil: 'api/setResponsabil/', // + id
                setAgent: 'api/setAgent/', // + id
                getResposabiliDepartament: 'api/proiecte/departament-responsibles/', // + id
                addResponsabil: 'api/proiect/responsible/', // + id proiect
                removeResponsabil: 'api/proiect/responsible/remove/', // + id record
                primaryResponsabil: 'api/proiect/responsible/primary/', // + id record
                addOperator: 'api/proiect/operator/', // + id proiect
                removeOperator: 'api/proiect/operator/remove/', // + id record
                primaryOperator: 'api/proiect/operator/primary/', // + id record

                updateSubject: 'api/proiect/subject/', // + id
                updateProvider: 'api/proiect/provider/', // + id
                updateTag: 'api/proiect/tag/', // + id
                updateCategorie: 'api/proiect/categdep/', // + id
                updateCompartiment: 'api/proiect/update/directie-compartiment/', // + id

                cancelProiect: 'api/proiect/cancel/', // + id
                closeProiect: 'api/proiect/close/', // + id
                updateGarantie: 'api/proiect/upload-garantie/', // + id
                uploadGarantieFiles: 'api/proiect/upload-garantie-files/', // + id
                downloadDocument: 'api/proiect/document/', // + id
                updateAdress: 'api/proiect/address/', // + id

                user: {
                    getUsersList: 'api/users-list-active-all',
                }
            },
            pushNotifications: {
                listDT: 'api/proiect/push-notifications/list-dt',
                find: 'api/proiect-push-notification/', // + id

                view: {
                    addImage: 'api/proiect/push-upload-image/', // + idPushNotification
                    deleteImage: 'api/proiect/push-image-delete/', // + id
                    getImage: 'api/proiect/push-image/', // + id
                }
            },
            nomenclatoare: {
                proiecteCategorii: {
                    list: 'api/proiecte/categorii/list',
                    listDT: 'api/proiecte/categorii/list-dt',
                    listActive: 'api/proiecte/categorii/list-active',
                    listByScale: 'api/proiecte/categorii/list-by-scale',
                    filter: 'api/proiecte/categorii/filter-categorii/', // + id sectiune
                    find: 'api/proiecte/categorii/', // + id
                    store: 'api/proiecte/categorii/store',
                    update: 'api/proiecte/categorii/update', // id in payload
                    changeActive: 'api/proiecte/categorii/status/', // + id
                    delete: 'api/proiecte/categorii/', // + id
                },
                proiecteSectiuni: {
                    list: 'api/proiecte/sectiuni/list',
                    listDT: 'api/proiecte/sectiuni/list-dt',
                    listAll: 'api/proiecte/sectiuni/all-list',
                    find: 'api/proiecte/sectiuni/', // + id
                    store: 'api/proiecte/sectiuni/store',
                    update: 'api/proiecte/sectiuni/update', // id in payload
                    delete: 'api/proiecte/sectiuni/', // + id
                },
                proiecteStatus: {
                    list: 'api/proiecte/status/list',
                    listDT: 'api/proiecte/status/list-dt',
                    listActive: 'api/proiecte/status/list-active',
                    listAllActive: 'api/proiecte/status/all-list-active',
                    find: 'api/proiecte/status/', // + id
                    store: 'api/proiecte/status/store',
                    update: 'api/proiecte/status/update', // id in payload
                    changeActive: 'api/proiecte/status/status/', // + id
                    delete: 'api/proiecte/status/', // + id
                },
                proiecteTag: {
                    list: 'api/proiecte/tag/list',
                    listDT: 'api/proiecte/tag/list-dt',
                    listActive: 'api/proiecte/tag/list-active',
                    listAllActive: 'api/proiecte/tag/all-list-active',
                    find: 'api/proiecte/tag/', // + id
                    store: 'api/proiecte/tag/store',
                    update: 'api/proiecte/tag/update', // id in payload
                    changeActive: 'api/proiecte/tag/status/', // + id
                    delete: 'api/proiecte/tag/', // + id
                    typehead: 'api/proiecte/tag-typeahead', // name in payload ?
                },
                proiecteProvider: {
                    list: 'api/proiecte/provider/list',
                    listDT: 'api/proiecte/provider/list-dt',
                    listActive: 'api/proiecte/provider/list-active',
                    listAllActive: 'api/proiecte/provider/all-list-active',
                    find: 'api/proiecte/provider/', // + id
                    store: 'api/proiecte/provider/store',
                    update: 'api/proiecte/provider/update', // id in payload
                    changeActive: 'api/proiecte/provider/status/', // + id
                    delete: 'api/proiecte/provider/', // + id
                    typehead: 'api/proiecte/provider-typeahead', // name in payload ?
                },
                proiecteAgent: {
                    list: 'api/proiecte/agent/list',
                    listDT: 'api/proiecte/agent/list-dt',
                    listActive: 'api/proiecte/agent/list-active',
                    find: 'api/proiecte/agent/', // + id
                    store: 'api/proiecte/agent/store',
                    update: 'api/proiecte/agent/update', // id in payload
                    changeActive: 'api/proiecte/agent/status/', // + id
                    delete: 'api/proiecte/agent/', // + id
                },
                proiecteMotiv: {
                    list: 'api/proiecte/motiv/list',
                    listDT: 'api/proiecte/motiv/list-dt',
                    listActive: 'api/proiecte/motiv/list-active',
                    find: 'api/proiecte/motiv/', // + id
                    store: 'api/proiecte/motiv/store',
                    update: 'api/proiecte/motiv/update', // id in payload
                    changeActive: 'api/proiecte/motiv/status/', // + id
                    delete: 'api/proiecte/motiv/', // + id
                },
                proiecteOperatori: {
                    list: 'api/settings/operatori/list',
                    listDT: 'api/settings/operatori/list-module-users',
                    listPermissions: 'api/settings/operatori/operator-servicii-permissions-list/', // + id
                    updatePermissions: 'api/settings/operatori/update-servicii-permissions/', // + id
                    updateFunctie: 'api/settings/operatori/operator-functie-update/', // + id
                    getFunctie: 'api/settings/operatori/operator-cereri-functie/', // + id
                },
                directie: {
                    list: 'api/directie/list',
                    listActive: 'api/directie/list/active',
                },
                compartiment: {
                    list: 'api/directie-compartiment/list',
                    listActive: 'api/directie-compartiment/list/active',
                    listByDirectie: 'api/directie-compartiment/listByDirectie/', // + id
                },
                functiiUser: {
                    list: 'api/nomenclatoare/functie/list',
                    listActive: 'api/nomenclatoare/functie/list/active',
                },
            },
        },
        authCore: {
            basePath: 'https://development.auth-core.webproductionlabs.com/',
            linkRedirectAuth: 'http://localhost:4100/#/aplicatii',
            platform: {
                getUserDetails: 'api/user/1/1', // get user from token and also validate token for operator to autorize actions
                getUserPermissionsAuthLib:
                    'api/client/module/permission/user/getUserPermissionsAuthLib/',
            },
        },
    },
};
